import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CssBaseline, Container, Typography, Box, Button, Stepper, Step, StepLabel, TextField, MenuItem, Chip, Radio, RadioGroup, FormControlLabel, Switch, Divider, CircularProgress, Alert, Tooltip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TablePagination } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import HeaderMenu from '../../components/header-menu';
import Footer from '../../components/footer';
import { injectIntl } from 'react-intl';
import * as componentActions from '../../redux/actions/header-menu';
import CustomizedSnackbars from '../../components/material-snackbars';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Check from '@mui/icons-material/Check';
import BoltIcon from '@mui/icons-material/Bolt';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import RepeatIcon from '@mui/icons-material/Repeat';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import Api from '../../services/api';
import MarketingService, { normalizeBroadcastDetail, normalizeList } from '../../services/marketing.service';
import { GetAllActiveAndByMessageProvider, getPhonesAssociations } from '../../services/2talk/channel';
import { getApprovedByRegistrationNumberRequestId, getApprovedOptInByRegistrationNumberRequestId } from '../../services/twotalk.template.message.service';
import { Overlay } from '../../styles/global';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const WHATSAPP_PROVIDER_ID = 2; // canal WhatsApp (tb_2talk_message_provider)

// Shape real do template (mesmos campos da automação de envio via provedor). Categoria/idioma vêm da API
// (sem valor chumbado); as variáveis {{n}} são derivadas do corpo.
const normalizeTemplate = (t = {}) => {
  const header = t.headertext ?? t.headerText ?? '';
  const body = t.bodytext ?? t.bodyText ?? t.body ?? '';
  const footer = t.footertext ?? t.footerText ?? '';
  const vars = Array.from(new Set((String(body).match(/\{\{\s*\d+\s*\}\}/g) || [])));
  return {
    id: t.id ?? t.Id,
    name: t.name ?? t.Name ?? '',
    language: t.language ?? t.templatelanguage ?? t.templateLanguage ?? '',
    category: t.category ?? t.templatecategory ?? t.templateCategory ?? '',
    header: String(header),
    body: String(body),
    footer: String(footer),
    system: t.system ?? t.System ?? false,   // optin: o default do número é o system=true
    vars,
  };
};

const normalizeChannel = (c = {}) => ({ id: c.id, name: c.name ?? c.channelname ?? `#${c.id}` });

// Serviços externos podem devolver array cru OU o corpo do CustomResponse ({ data: [...] }).
const asArray = (raw) => (Array.isArray(raw) ? raw : (raw && Array.isArray(raw.data) ? raw.data : []));

// Ícone de step customizado: ativo ganha anel/glow + leve zoom; concluído vira check verde;
// futuro fica apagado. Dá um destaque claro de "onde estou" no wizard.
function StepCircle(props) {
  const { active, completed, icon } = props;
  const base = {
    width: 34, height: 34, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 14, fontWeight: 700, transition: 'all .25s ease',
  };
  if (completed) return <Box sx={{ ...base, backgroundColor: '#5b9b1e', color: '#fff' }}><Check sx={{ fontSize: 18 }} /></Box>;
  if (active) return (
    <Box sx={{ ...base, backgroundColor: '#8BC34A', color: '#fff', transform: 'scale(1.18)', boxShadow: '0 0 0 5px rgba(139,195,74,0.25), 0 4px 10px rgba(139,195,74,0.45)' }}>{icon}</Box>
  );
  return <Box sx={{ ...base, backgroundColor: '#efefef', color: '#a0a0a0' }}>{icon}</Box>;
}

// Campos do contato disponíveis pra mapear variáveis (ids alinhados ao snapshot do backend:
// name/phone/email/document; colunas extras de CSV também viram chaves no extra_fields).
const CONTACT_FIELDS = [
  { id: 'name', name: 'Nome' },
  { id: 'phone', name: 'Telefone' },
  { id: 'email', name: 'E-mail' },
  { id: 'document', name: 'Documento' },
];
const SAMPLE_CONTACTS = [
  { name: 'João Silva', phone: '+5511999990001', email: 'joao@exemplo.com', document: '123.456.789-00' },
  { name: 'Maria Souza', phone: '+5511999990002', email: 'maria@exemplo.com', document: '987.654.321-00' },
  { name: '', phone: '+5511999990003', email: '', document: '456.789.123-00' },
];
const WEEKDAYS = [
  { id: 0, label: 'D' }, { id: 1, label: 'S' }, { id: 2, label: 'T' }, { id: 3, label: 'Q' },
  { id: 4, label: 'Q' }, { id: 5, label: 'S' }, { id: 6, label: 'S' },
];
const WEEKDAY_NAMES = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
const NTH_LABELS = { 1: 'primeira', 2: 'segunda', 3: 'terceira', 4: 'quarta', '-1': 'última' };
// Idiomas disponíveis do template (mock). Custo unitário por categoria Meta (USD, referência mock).
const TIMEZONES = [{ id: 'America/Sao_Paulo', name: 'America/Sao_Paulo (GMT-3)' }, { id: 'America/Manaus', name: 'America/Manaus (GMT-4)' }, { id: 'America/New_York', name: 'America/New_York (GMT-5)' }, { id: 'Europe/Lisbon', name: 'Europe/Lisbon (GMT+0)' }];
const META_PRICING = { Marketing: 0.0625, Utility: 0.035, Authentication: 0.035 };

class MarketingBroadcastNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      saving: false,
      notification: { open: false, variant: 'success', message: '' },
      // catálogos carregados do backend
      channels: [], senders: [], templates: [], lists: [], optinTemplates: [],
      loadingChannels: false, loadingSenders: false, loadingTemplates: false, loadingOptin: false,
      // dados
      name: '',
      channelId: '',
      senderId: '',
      listId: '',
      templateId: '',
      optinTemplateId: '',   // template de opt-in (pré-selecionado no padrão do número; usuário pode trocar)
      language: '',     // idioma do template (req. seção 1)
      varMapping: {},   // { '{{1}}': { mode:'field'|'fixed', field:'nome', fixed:'', fallback:'' } }
      loadedStatus: '', // status original da transmissão na edição (draft|scheduled|...) — define rótulo do botão
      testPhone: '55',   // telefone de teste — já vem com o DDI do país (Brasil); usuário digita só o número
      savedDraftId: null,   // id do rascunho salvo inline no passo 4 (pra testar sem sair)
      // preview dos destinatários (modal paginado + download CSV) — reusa contatos da lista alvo
      rcpPreviewOpen: false, rcpPage: 0, rcpRpp: 25, rcpItems: [], rcpLoading: false, rcpDownloading: false,
      noOptinCount: null,   // contatos válidos sem opt-in p/ o número (null = carregando/indisponível)
      // Agendamento completo (uma vez OU recorrente — estilo Zendesk/Intercom).
      schedule: {
        mode: 'now', // now | once | recurring
        onceAt: '',
        timezone: 'America/Sao_Paulo',
        quietHours: false,
        slice: false,
        sliceBatch: 2000,    // tamanho do lote quando fatiar
        sliceInterval: 15,   // intervalo entre lotes (min)
        recurrence: {
          freq: 'weekly',           // daily | weekly | monthly
          time: '09:00',
          interval: 1,              // a cada N (dias/semanas/meses)
          weekdays: [3],            // weekly: dias selecionados (0=dom..6=sáb)
          monthlyMode: 'dayOfMonth',// dayOfMonth | nthWeekday
          dayOfMonth: 1,
          nth: 1,                   // 1..4 ou -1 (última)
          nthWeekday: 4,            // dia da semana (0..6)
          endMode: 'never',         // never | count | date — condição de término
          endCount: 5,              // count: nº total de execuções
          endDate: '',              // date: até DD/MM/AAAA (YYYY-MM-DD no state)
        },
      },
    };
  }

  get lang() { return (window.location.pathname.split('/')[1]) || 'pt'; }
  // Aba de origem (?tab=) pra "Voltar"/cancelar retornar pra ela; na edição cai no status carregado.
  get originTab() {
    const t = new URLSearchParams(this.props.location ? this.props.location.search : '').get('tab');
    return t || this.state.loadedStatus || '';
  }
  goMarketing = (tab) => this.props.history.push(`/${this.lang}/marketing${tab ? `?tab=${tab}` : ''}`);
  get editId() { return this.props.match && this.props.match.params ? this.props.match.params.id : null; }
  get isEdit() { return !!this.editId; }
  // id efetivo da transmissão (rota de edição OU rascunho salvo inline no passo 4).
  get currentId() { return this.editId || this.state.savedDraftId; }
  // Publicar (programar/enviar) = admin/global/coordenador. Técnico só salva rascunho.
  get userRoles() { const u = this.props.userSession; return (u && u.user && Array.isArray(u.user.userrole)) ? u.user.userrole : []; }
  canPublish = () => this.userRoles.some(ur => ur && ur.role && [0, 1, 4].includes(Number(ur.role.roletype)));

  // Autocomplete padrão do projeto, mantendo o state por id (filtra ao digitar).
  acField = (label, options, valueId, onPick, extra = {}) => (
    <SimpleAutoComplete label={label} options={options} size="small" stateName="ac"
      selected={options.find(o => o.id === valueId) || { id: 0, name: '' }}
      changeSelect={(n, v) => onPick(v && v.id ? v.id : '')} {...extra} />
  );

  componentDidMount() {
    this.loadCatalogs();
  }

  loadCatalogs = async () => {
    // Canais: somente WhatsApp (message_provider_id = 2), ativos.
    this.setState({ loadingChannels: true });
    try {
      const channelsRaw = await GetAllActiveAndByMessageProvider(WHATSAPP_PROVIDER_ID);
      this.setState({ channels: asArray(channelsRaw).map(normalizeChannel), loadingChannels: false });
    } catch (err) { this.setState({ loadingChannels: false }); /* catálogo vazio não quebra o wizard */ }

    // Listas (endpoint próprio do marketing)
    try {
      const result = await MarketingService.listLists();
      const lists = (result.data && result.data.success && Array.isArray(result.data.data)) ? result.data.data.map(normalizeList) : [];
      this.setState({ lists });
    } catch (err) { /* idem */ }

    if (this.isEdit) await this.loadBroadcastForEdit();
  };

  // Números do canal selecionado (registros associados ao canal). Depende do canal.
  loadSenders = (channelId, after) => {
    if (!channelId) { this.setState({ senders: [], loadingSenders: false }, after); return; }
    this.setState({ loadingSenders: true });
    getPhonesAssociations(channelId)
      .then(raw => {
        const rows = asArray(raw && raw.data ? raw.data : raw);
        const senders = rows
          .filter(r => r && r.registrationnumberrequest && (r.active === undefined || r.active) )
          .map(r => ({ id: r.registrationnumberrequest.id, phone: r.registrationnumberrequest.phonenumber ?? '', name: '' }));
        this.setState({ senders, loadingSenders: false }, after);
      })
      .catch(() => this.setState({ senders: [], loadingSenders: false }, after));
  };

  loadBroadcastForEdit = async () => {
    try {
      const result = await MarketingService.getBroadcast(this.editId);
      if (!(result.data && result.data.success)) return;
      const d = normalizeBroadcastDetail(result.data.data);
      // varMapping array -> objeto { '{{n}}': {mode,field,fixed,fallback} }
      const varMapping = {};
      (d.varMapping || []).forEach(v => { varMapping[v.placeholder] = { mode: v.mode, field: v.field, fixed: v.fixed, fallback: v.fallback }; });
      this.setState(prev => ({
        name: d.name || '', channelId: d.channelId || '', senderId: d.senderId || '', listId: d.listId || '',
        templateId: d.templateId || '', optinTemplateId: d.optinTemplateId || '', language: d.language || '', varMapping, loadedStatus: d.status || '',
        schedule: { ...prev.schedule, ...d.schedule },
      }));
      if (d.channelId) this.loadSenders(d.channelId);
      if (d.senderId) { this.loadTemplates(d.senderId); this.loadOptinTemplates(d.senderId, true); }
      this.loadNoOptIn();
    } catch (err) { Api.kickoff(err); }
  };

  loadTemplates = (senderId) => {
    if (!senderId) { this.setState({ templates: [] }); return; }
    this.setState({ loadingTemplates: true });
    getApprovedByRegistrationNumberRequestId(senderId)
      .then(raw => this.setState({ templates: asArray(raw).map(normalizeTemplate), loadingTemplates: false }))
      .catch(() => this.setState({ templates: [], loadingTemplates: false }));
  };

  // Templates de opt-in aprovados do número. Pré-seleciona o padrão (system=true) se o usuário ainda não escolheu.
  loadOptinTemplates = (senderId, keepSelection = false) => {
    if (!senderId) { this.setState({ optinTemplates: [], optinTemplateId: '' }); return; }
    this.setState({ loadingOptin: true });
    getApprovedOptInByRegistrationNumberRequestId(senderId)
      .then(raw => {
        const optinTemplates = asArray(raw).map(normalizeTemplate);
        this.setState(prev => {
          const stillValid = keepSelection && optinTemplates.some(t => t.id === prev.optinTemplateId);
          const def = optinTemplates.find(t => t.system) || optinTemplates[0];
          return {
            optinTemplates,
            optinTemplateId: stillValid ? prev.optinTemplateId : (def ? def.id : ''),
            loadingOptin: false,
          };
        });
      })
      .catch(() => this.setState({ optinTemplates: [], optinTemplateId: '', loadingOptin: false }));
  };

  // Sem endpoint de unicidade de nome no V1 — a validação de duplicidade fica desativada.
  isDuplicateName = () => false;

  // Estimativa de custo (req. seção 4/5): nº de válidos × preço unitário da categoria Meta.
  costEstimate = () => {
    const list = this.selectedList();
    const count = list ? list.valid : 0;
    const unit = META_PRICING.Marketing;   // feature de marketing; preço de referência Meta
    return { count, unit, total: unit * count };
  };

  // helpers de agendamento
  patchSchedule = (patch) => this.setState(p => ({ schedule: { ...p.schedule, ...patch } }));
  patchRecurrence = (patch) => this.setState(p => ({ schedule: { ...p.schedule, recurrence: { ...p.schedule.recurrence, ...patch } } }));
  toggleWeekday = (id) => {
    const cur = this.state.schedule.recurrence.weekdays;
    this.patchRecurrence({ weekdays: cur.includes(id) ? cur.filter(d => d !== id) : [...cur, id].sort() });
  };

  // Resumo legível da recorrência (o que o concorrente grande mostra pro usuário).
  recurrenceSummary = () => {
    const { schedule } = this.state;
    if (schedule.mode === 'now') return this.props.intl.formatMessage({ id: 'marketing.schedule.summary.now' });
    if (schedule.mode === 'once') return schedule.onceAt ? `${this.props.intl.formatMessage({ id: 'marketing.schedule.summary.once' })} ${schedule.onceAt.replace('T', ' ')}` : '—';
    const r = schedule.recurrence;
    const every = r.interval > 1 ? `${r.interval} ` : '';
    let base;
    if (r.freq === 'daily') base = `A cada ${every}dia(s) às ${r.time}`;
    else if (r.freq === 'weekly') {
      const days = r.weekdays.length ? r.weekdays.map(d => WEEKDAY_NAMES[d]).join(', ') : '—';
      base = `${r.interval > 1 ? `A cada ${r.interval} semanas` : 'Toda semana'} (${days}) às ${r.time}`;
    }
    else if (r.monthlyMode === 'dayOfMonth') base = `Mensalmente no dia ${r.dayOfMonth} às ${r.time}`;
    else base = `Mensalmente na ${NTH_LABELS[r.nth]} ${WEEKDAY_NAMES[r.nthWeekday]} às ${r.time}`;
    // Condição de término
    let end = '';
    if (r.endMode === 'count' && r.endCount) end = ` · até ${r.endCount} execuç${r.endCount > 1 ? 'ões' : 'ão'}`;
    else if (r.endMode === 'date' && r.endDate) end = ` · até ${r.endDate.split('-').reverse().join('/')}`;
    return base + end;
  };
  get steps() {
    const { intl } = this.props;
    return [
      intl.formatMessage({ id: 'marketing.step.data' }),
      intl.formatMessage({ id: 'marketing.step.recipients' }),
      intl.formatMessage({ id: 'marketing.step.template' }),
      intl.formatMessage({ id: 'marketing.step.review' }),
      intl.formatMessage({ id: 'marketing.step.schedule' }),
    ];
  }

  selectedTemplate = () => this.state.templates.find(t => t.id === this.state.templateId);
  selectedList = () => {
    const l = this.state.lists.find(x => x.id === this.state.listId);
    return l ? { ...l, invalid: Math.max(0, (l.total || 0) - (l.valid || 0)) } : undefined;
  };

  // "Sem opt-in": só calcula quando há lista E número selecionados (depende do número de envio).
  loadNoOptIn = () => {
    const { listId, senderId } = this.state;
    if (!listId || !senderId) { this.setState({ noOptinCount: null }); return; }
    this.setState({ noOptinCount: null });
    MarketingService.getNoOptInCount(listId, senderId)
      .then(r => {
        const c = (r.data && r.data.success && r.data.data) ? (r.data.data.count ?? 0) : 0;
        this.setState({ noOptinCount: c });
      })
      .catch(() => this.setState({ noOptinCount: null }));
  };

  // Preview dos destinatários: abre o modal e carrega a página (paginação no servidor; total = list.total).
  openRecipientsPreview = () => { if (!this.state.listId) return; this.setState({ rcpPreviewOpen: true, rcpPage: 0 }, () => this.loadRecipientsPage(0, this.state.rcpRpp)); };
  closeRecipientsPreview = () => this.setState({ rcpPreviewOpen: false });
  loadRecipientsPage = (page, rpp) => {
    this.setState({ rcpLoading: true });
    MarketingService.getListContacts(this.state.listId, page + 1, rpp)
      .then(result => {
        const items = (result.data && result.data.success && Array.isArray(result.data.data))
          ? result.data.data.map(c => ({ name: c.name, phone: c.phone })) : [];
        this.setState({ rcpItems: items, rcpLoading: false });
      })
      .catch(() => this.setState({ rcpItems: [], rcpLoading: false }));
  };
  changeRcpPage = (page) => this.setState({ rcpPage: page }, () => this.loadRecipientsPage(page, this.state.rcpRpp));
  changeRcpRpp = (rpp) => this.setState({ rcpRpp: rpp, rcpPage: 0 }, () => this.loadRecipientsPage(0, rpp));
  downloadRecipientsCsv = async () => {
    if (!this.state.listId) return;
    this.setState({ rcpDownloading: true });
    try {
      const result = await MarketingService.exportListCsv(this.state.listId);
      const blob = new Blob([result.data], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `marketing-lista-${this.state.listId}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) { Api.kickoff(err); }
    finally { this.setState({ rcpDownloading: false }); }
  };

  setVarMapping = (v, patch) => this.setState(prev => ({
    varMapping: { ...prev.varMapping, [v]: { mode: 'field', field: '', fixed: '', fallback: '', ...prev.varMapping[v], ...patch } }
  }));

  // Resolve uma variável pra um contato amostra (preview real, como pede o documento).
  resolveVar = (v, contact) => {
    const m = this.state.varMapping[v] || { mode: 'field', field: '', fallback: '' };
    if (m.mode === 'fixed') return m.fixed || `[${v}]`;
    const val = contact[m.field];
    return (val && String(val).trim()) ? val : (m.fallback || `[${m.field}]`);
  };

  renderPreview = (contact) => {
    const tpl = this.selectedTemplate();
    if (!tpl) return '';
    let body = tpl.body;
    tpl.vars.forEach(v => { body = body.split(v).join(this.resolveVar(v, contact)); });
    return body;
  };

  canNext = () => {
    switch (this.state.activeStep) {
      case 0: return this.state.name.trim() && !this.isDuplicateName() && this.state.channelId && this.state.senderId;
      case 1: return !!this.state.listId;
      case 2: {
        if (!this.state.templateId) return false;
        const tpl = this.selectedTemplate();
        const vars = tpl ? tpl.vars : [];
        // Cada variável precisa estar mapeada: modo 'fixed' com valor, ou 'field' com campo escolhido.
        return vars.every(v => {
          const m = this.state.varMapping[v];
          if (!m) return false;
          return m.mode === 'fixed' ? !!(m.fixed && m.fixed.trim()) : !!(m.field && m.field.trim());
        });
      }
      default: return true;
    }
  };

  next = () => this.setState(p => ({ activeStep: Math.min(p.activeStep + 1, 4) }));
  back = () => this.setState(p => ({ activeStep: Math.max(p.activeStep - 1, 0) }));
  // Atalho na edição: clicar no passo do stepper pula direto pra ele (dados já carregados).
  goToStep = (i) => { if (this.isEdit) this.setState({ activeStep: i }); };

  // Sugere um nome com data/hora atual (ex.: "Envio em lote em sexta-feira, 26/06/2026 às 15:44").
  // Usa toLocaleDateString (nativo) p/ o dia da semana no idioma correto, sem depender de locale do moment.
  suggestName = () => {
    const lang = this.lang === 'pt' ? 'pt-BR' : this.lang === 'es' ? 'es-ES' : 'en-US';
    const now = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    const weekday = now.toLocaleDateString(lang, { weekday: 'long' });
    const date = `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()}`;
    const time = `${pad(now.getHours())}:${pad(now.getMinutes())}`;
    this.setState({ name: this.props.intl.formatMessage({ id: 'marketing.create.suggestedName' }, { weekday, date, time }) });
  };
  cancel = () => this.goMarketing(this.originTab);

  sendTest = async () => {
    const { intl } = this.props;
    if (!this.currentId) {
      this.setState({ notification: { open: true, variant: 'error', message: intl.formatMessage({ id: 'marketing.test.saveFirst' }) } });
      return;
    }
    const phone = (this.state.testPhone || '').replace(/\D/g, '');
    if (phone.length < 12) return;
    this.setState({ saving: true });
    try {
      const result = await MarketingService.testBroadcast(this.currentId, phone);
      if (result.data && result.data.success) {
        this.setState({ notification: { open: true, variant: 'success', message: intl.formatMessage({ id: 'marketing.test.sent' }) } });
      } else {
        this.setState({ notification: { open: true, variant: 'error', message: (result.data && result.data.errors && result.data.errors[0]) || intl.formatMessage({ id: 'marketing.toast.error' }) } });
      }
    } catch (err) { Api.kickoff(err); }
    finally { this.setState({ saving: false }); }
  };

  buildModel = () => {
    const tpl = this.selectedTemplate();
    const vars = tpl ? tpl.vars : Object.keys(this.state.varMapping);
    const varMapping = vars.map(v => {
      const m = this.state.varMapping[v] || { mode: 'field', field: '', fixed: '', fallback: '' };
      return { placeholder: v, mode: m.mode, field: m.field, fixed: m.fixed, fallback: m.fallback };
    });
    return {
      name: this.state.name, channelId: this.state.channelId, senderId: this.state.senderId,
      templateId: this.state.templateId, language: this.state.language, listId: this.state.listId,
      optinTemplateId: this.state.optinTemplateId || null,
      varMapping, schedule: this.state.schedule,
    };
  };

  // target: 'draft' (fica Rascunho) | 'active' (Enviar agora) | 'scheduled' (Programar).
  // Salvar rascunho SEM sair da tela (passo 4) — habilita testar logo em seguida.
  saveDraftInline = async () => {
    const { intl } = this.props;
    const model = this.buildModel();
    this.setState({ saving: true });
    try {
      const id = this.currentId;
      const result = id
        ? await MarketingService.updateBroadcast(id, model, 'draft')
        : await MarketingService.createBroadcast(model, 'draft');
      if (result.data && result.data.success) {
        const newId = id || (result.data.data && result.data.data.id);
        this.setState({ saving: false, savedDraftId: newId || id, notification: { open: true, variant: 'success', message: intl.formatMessage({ id: 'marketing.toast.draftSaved' }) } });
      } else {
        this.setState({ saving: false, notification: { open: true, variant: 'error', message: (result.data && result.data.errors && result.data.errors[0]) || intl.formatMessage({ id: 'marketing.toast.error' }) } });
      }
    } catch (err) {
      this.setState({ saving: false, notification: { open: true, variant: 'error', message: this.extractError(err) } });
      Api.kickoff(err);
    }
  };

  submit = async (target) => {
    const { intl } = this.props;
    const action = target === 'draft' ? 'draft' : target === 'scheduled' ? 'schedule' : 'send';
    const model = this.buildModel();
    this.setState({ saving: true });
    try {
      const id = this.currentId;
      const result = id
        ? await MarketingService.updateBroadcast(id, model, action)
        : await MarketingService.createBroadcast(model, action);
      if (result.data && result.data.success) {
        const msgId = action === 'draft' ? 'marketing.toast.draftSaved' : action === 'schedule' ? 'marketing.toast.scheduled' : 'marketing.create.success';
        this.setState({ saving: false, notification: { open: true, variant: 'success', message: intl.formatMessage({ id: msgId }) } });
        // Após salvar, vai pra aba do status resultante (draft|scheduled|active = o próprio target).
        setTimeout(() => this.goMarketing(target), 900);
      } else {
        this.setState({ saving: false, notification: { open: true, variant: 'error', message: (result.data && result.data.errors && result.data.errors[0]) || intl.formatMessage({ id: 'marketing.toast.error' }) } });
      }
    } catch (err) {
      // CustomResponse devolve BadRequest (400) nas críticas → cai aqui; exibe o erro do back no toast vermelho.
      this.setState({ saving: false, notification: { open: true, variant: 'error', message: this.extractError(err) } });
      Api.kickoff(err);
    }
  };

  // Mensagem de erro vinda do backend (CustomResponse 400) ou fallback genérico.
  extractError = (err) => {
    const errs = err && err.response && err.response.data && err.response.data.errors;
    return (Array.isArray(errs) && errs[0]) || this.props.intl.formatMessage({ id: 'marketing.toast.error' });
  };

  field = (props) => <TextField fullWidth size="small" InputLabelProps={{ shrink: true }} {...props} />;

  renderStepData() {
    const { intl } = this.props;
    const F = this.field;
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 560 }}>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1 }}>
            <F label={intl.formatMessage({ id: 'marketing.field.name' })} value={this.state.name} onChange={e => this.setState({ name: e.target.value })}
              error={this.isDuplicateName()} helperText={this.isDuplicateName() ? intl.formatMessage({ id: 'marketing.field.nameDup' }) : ''} />
          </Box>
          {/* Sugerir nome: só na inclusão (na edição o nome já existe). */}
          {!this.isEdit && (
            <Button variant="outlined" startIcon={<AutoAwesomeOutlinedIcon />} onClick={this.suggestName}
              sx={{ textTransform: 'none', whiteSpace: 'nowrap', mt: 0.25, borderColor: '#cfcfcf', color: '#444', flexShrink: 0 }}>
              {intl.formatMessage({ id: 'marketing.create.suggestName' })}
            </Button>
          )}
        </Box>
        {this.acField(intl.formatMessage({ id: 'marketing.field.channel' }), this.state.channels, this.state.channelId,
          (id) => { this.setState({ channelId: id, senderId: '', templateId: '', varMapping: {}, senders: [], templates: [], optinTemplates: [], optinTemplateId: '', noOptinCount: null }); this.loadSenders(id); }, { loading: this.state.loadingChannels })}
        {this.acField(intl.formatMessage({ id: 'marketing.field.sender' }), this.state.senders.map(s => ({ id: s.id, name: `${s.phone}${s.name ? ` (${s.name})` : ''}` })), this.state.senderId,
          (id) => { this.setState({ senderId: id, templateId: '', varMapping: {} }, this.loadNoOptIn); this.loadTemplates(id); this.loadOptinTemplates(id); }, { loading: this.state.loadingSenders })}
        {/* Sem número registrado ativo pro canal: avisa em vez de combo vazio silencioso */}
        {this.state.channelId && !this.state.loadingSenders && this.state.senders.length === 0 && (
          <Alert severity="warning" action={
            <Button color="inherit" size="small" sx={{ textTransform: 'none' }} onClick={() => this.props.history.push(`/${this.lang}/channel`)}>
              {intl.formatMessage({ id: 'marketing.field.registerNumber' })}
            </Button>
          }>{intl.formatMessage({ id: 'marketing.field.noActiveNumber' })}</Alert>
        )}
      </Box>
    );
  }

  renderStepRecipients() {
    const { intl } = this.props;
    const list = this.selectedList();
    return (
      <Box sx={{ maxWidth: 620 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{intl.formatMessage({ id: 'marketing.field.list' })}</Typography>
          <Button size="small" sx={{ textTransform: 'none' }} onClick={() => this.props.history.push(`/${this.lang}/marketing/lists${this.originTab ? `?tab=${this.originTab}` : ''}`)}>
            {intl.formatMessage({ id: 'marketing.manage.lists' })}
          </Button>
        </Box>
        {this.acField(intl.formatMessage({ id: 'marketing.field.list' }), this.state.lists.map(l => ({ id: l.id, name: `${l.name} (${l.total})` })), this.state.listId, (id) => this.setState({ listId: id }, this.loadNoOptIn))}

        {list && (
          <Box sx={{ display: 'flex', gap: 1.5, mt: 2, flexWrap: 'wrap' }}>
            {/* Válidos: clicável → abre o preview de quem irá receber (paginado + download CSV) */}
            <Tooltip title={intl.formatMessage({ id: 'marketing.recipients.validTooltip' })} arrow>
              <Box onClick={this.openRecipientsPreview} sx={{ flex: 1, minWidth: 120, border: '1px solid #cfe8bf', borderRadius: '10px', p: 1.5, cursor: 'pointer', transition: 'all .15s', '&:hover': { backgroundColor: '#f3fae9', borderColor: '#8BC34A' } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 22, fontWeight: 700, color: '#5b9b1e' }}>{list.valid}</Typography>
                  <VisibilityOutlinedIcon sx={{ fontSize: 18, color: '#8BC34A' }} />
                </Box>
                <Typography sx={{ fontSize: 12, color: '#888' }}>{intl.formatMessage({ id: 'marketing.recipients.valid' })}</Typography>
              </Box>
            </Tooltip>
            <Box sx={{ flex: 1, minWidth: 120, border: '1px solid #e0e0e0', borderRadius: '10px', p: 1.5 }}>
              <Typography sx={{ fontSize: 22, fontWeight: 700, color: '#c0392b' }}>{list.invalid}</Typography>
              <Typography sx={{ fontSize: 12, color: '#888' }}>{intl.formatMessage({ id: 'marketing.recipients.invalid' })}</Typography>
            </Box>
            <Tooltip title={intl.formatMessage({ id: this.state.senderId ? 'marketing.recipients.noOptinTooltip' : 'marketing.recipients.noOptinPickSender' })} arrow>
              <Box sx={{ flex: 1, minWidth: 120, border: '1px solid #e0e0e0', borderRadius: '10px', p: 1.5 }}>
                <Typography sx={{ fontSize: 22, fontWeight: 700, color: '#e67e22' }}>
                  {!this.state.senderId ? '—' : this.state.noOptinCount === null ? <CircularProgress size={18} sx={{ color: '#e67e22' }} /> : this.state.noOptinCount}
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#888' }}>{intl.formatMessage({ id: 'marketing.recipients.noOptin' })}</Typography>
              </Box>
            </Tooltip>
          </Box>
        )}
        {list && list.invalid > 0 && <Alert severity="info" sx={{ mt: 2 }}>{intl.formatMessage({ id: 'marketing.recipients.invalidNote' })}</Alert>}
        {this.renderRecipientsPreviewDialog()}
      </Box>
    );
  }

  // Modal: quem irá receber (contatos da lista, paginado no servidor) + botão Baixar .CSV.
  renderRecipientsPreviewDialog() {
    const { intl } = this.props;
    const list = this.selectedList();
    const total = list ? (list.total || 0) : 0;
    return (
      <Dialog open={this.state.rcpPreviewOpen} onClose={this.closeRecipientsPreview} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '12px', maxHeight: '85vh' } }}>
        <DialogTitle sx={{ fontSize: 18, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
          <Box>
            {intl.formatMessage({ id: 'marketing.recipients.preview.title' })}
            <Typography sx={{ fontSize: 12, color: '#888', fontWeight: 400 }}>{total} {intl.formatMessage({ id: 'marketing.list.preview.count' })}</Typography>
          </Box>
          <Button variant="outlined" size="small" startIcon={this.state.rcpDownloading ? <CircularProgress size={14} /> : <FileDownloadOutlinedIcon />}
            onClick={this.downloadRecipientsCsv} disabled={this.state.rcpDownloading}
            sx={{ textTransform: 'none', borderColor: '#cfcfcf', color: '#444', whiteSpace: 'nowrap' }}>
            {intl.formatMessage({ id: 'marketing.action.downloadCsv' })}
          </Button>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <Box sx={{ maxHeight: '55vh', overflowY: 'auto', position: 'relative' }}>
            {this.state.rcpLoading && (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress sx={{ color: '#8BC34A' }} /></Box>
            )}
            {!this.state.rcpLoading && (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr style={{ backgroundColor: '#fafafa', position: 'sticky', top: 0 }}>
                  <th style={{ textAlign: 'left', padding: '8px 12px', fontSize: 12, color: '#888', fontWeight: 600, backgroundColor: '#fafafa' }}>{intl.formatMessage({ id: 'marketing.list.col.name' })}</th>
                  <th style={{ textAlign: 'left', padding: '8px 12px', fontSize: 12, color: '#888', fontWeight: 600, backgroundColor: '#fafafa' }}>{intl.formatMessage({ id: 'marketing.col.sender' })}</th>
                </tr></thead>
                <tbody>
                  {this.state.rcpItems.map((c, i) => (
                    <tr key={i}>
                      <td style={{ padding: '8px 12px', fontSize: 13, borderTop: '1px solid #f5f5f5' }}>{c.name}</td>
                      <td style={{ padding: '8px 12px', fontSize: 13, borderTop: '1px solid #f5f5f5', whiteSpace: 'nowrap' }}>{c.phone}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Box>
          <TablePagination component="div" count={total} page={this.state.rcpPage} rowsPerPage={this.state.rcpRpp}
            rowsPerPageOptions={[10, 25, 50, 100]}
            onPageChange={(_e, p) => this.changeRcpPage(p)}
            onRowsPerPageChange={(e) => this.changeRcpRpp(parseInt(e.target.value, 10))}
            labelRowsPerPage={intl.formatMessage({ id: 'marketing.list.preview.perPage' })}
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`} />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={this.closeRecipientsPreview} sx={{ textTransform: 'none' }}>{intl.formatMessage({ id: 'close' })}</Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderStepTemplate() {
    const { intl } = this.props;
    const tpl = this.selectedTemplate();
    return (
      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <Box sx={{ flex: '1 1 460px', minWidth: 0, maxWidth: 720 }}>
        {/* Atalho pra gerenciar modelos (templates), igual ao "Gerenciar listas" do passo 2 */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{intl.formatMessage({ id: 'marketing.field.template' })}</Typography>
          <Button size="small" startIcon={<DescriptionOutlinedIcon fontSize="small" />} sx={{ textTransform: 'none' }}
            onClick={() => this.props.history.push(`/${this.lang}/template-message`)}>
            {intl.formatMessage({ id: 'marketing.manage.templates' })}
          </Button>
        </Box>
        {this.acField(intl.formatMessage({ id: 'marketing.field.template' }), this.state.templates.map(t => ({ id: t.id, name: `${t.name}${t.category ? ` · ${t.category}` : ''}` })), this.state.templateId,
          (id) => { const t = this.state.templates.find(x => x.id === id); this.setState({ templateId: id, varMapping: {}, language: t ? t.language : '' }); }, { loading: this.state.loadingTemplates })}

        {/* Sem template aprovado pro número: avisa e leva pra gestão de modelos */}
        {this.state.senderId && !this.state.loadingTemplates && this.state.templates.length === 0 && (
          <Alert severity="warning" sx={{ mt: 1 }} action={
            <Button color="inherit" size="small" sx={{ textTransform: 'none' }} onClick={() => this.props.history.push(`/${this.lang}/template-message`)}>
              {intl.formatMessage({ id: 'marketing.manage.templates' })}
            </Button>
          }>{intl.formatMessage({ id: 'marketing.field.noApprovedTemplate' })}</Alert>
        )}

        {tpl && (
          <>
            {/* Categoria + idioma vêm do próprio template aprovado (não editável aqui). */}
            <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap', alignItems: 'center' }}>
              {tpl.category && (
                <Chip size="small" label={`${intl.formatMessage({ id: 'marketing.template.category' })}: ${tpl.category}`}
                  sx={{ borderRadius: '6px', fontWeight: 700, backgroundColor: '#f4ecfa', color: '#8e44ad', border: '1px solid #e0c8f0' }} />
              )}
              {tpl.language && (
                <Chip size="small" label={tpl.language}
                  sx={{ borderRadius: '6px', fontWeight: 600, backgroundColor: '#eef2f7', color: '#475569', border: '1px solid #dbe2ea' }} />
              )}
            </Box>

            {/* Pré-visualização do template (header/body/footer) — corpo agora carregado do template aprovado. */}
            <Box sx={{ mt: 2, p: 1.5, backgroundColor: '#e9fde3', border: '1px solid #cfe8bf', borderRadius: '10px' }}>
              <Typography sx={{ fontSize: 11, color: '#5b9b1e', fontWeight: 600, mb: 0.5 }}>{intl.formatMessage({ id: 'marketing.template.body' })}</Typography>
              {tpl.header && <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#0f172a', whiteSpace: 'pre-wrap', mb: 0.5 }}>{tpl.header}</Typography>}
              <Typography sx={{ fontSize: 14, color: '#333', whiteSpace: 'pre-wrap' }}>{tpl.body}</Typography>
              {tpl.footer && <Typography sx={{ fontSize: 12, color: '#64748b', mt: 0.5, fontStyle: 'italic', whiteSpace: 'pre-wrap' }}>{tpl.footer}</Typography>}
            </Box>

            <Alert severity="info" sx={{ mt: 1.5 }}>{intl.formatMessage({ id: 'marketing.template.window24h' })}</Alert>

            <Typography sx={{ fontSize: 14, fontWeight: 600, mt: 2.5, mb: 1 }}>{intl.formatMessage({ id: 'marketing.template.variables' })}</Typography>
            {tpl.vars.map(v => {
              const m = this.state.varMapping[v] || { mode: 'field', field: '', fixed: '', fallback: '' };
              return (
                <Box key={v} sx={{ border: '1px solid #e8e8e8', borderRadius: '10px', p: 1.5, mb: 1.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <Chip size="small" label={v} sx={{ backgroundColor: '#eef7e3', color: '#5b9b1e', fontWeight: 700, borderRadius: '6px' }} />
                    <RadioGroup row value={m.mode} onChange={e => this.setVarMapping(v, { mode: e.target.value })}>
                      <FormControlLabel value="field" control={<Radio size="small" />} label={intl.formatMessage({ id: 'marketing.var.field' })} />
                      <FormControlLabel value="fixed" control={<Radio size="small" />} label={intl.formatMessage({ id: 'marketing.var.fixed' })} />
                    </RadioGroup>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                    {m.mode === 'field' ? (
                      <Box sx={{ minWidth: 200, flex: '0 1 220px' }}>
                        {this.acField(intl.formatMessage({ id: 'marketing.var.contactField' }), CONTACT_FIELDS, m.field, (id) => this.setVarMapping(v, { field: id }))}
                      </Box>
                    ) : (
                      <TextField size="small" InputLabelProps={{ shrink: true }} sx={{ minWidth: 220 }}
                        label={intl.formatMessage({ id: 'marketing.var.fixedValue' })} value={m.fixed} onChange={e => this.setVarMapping(v, { fixed: e.target.value })} />
                    )}
                    {m.mode === 'field' && (
                      <TextField size="small" InputLabelProps={{ shrink: true }} sx={{ minWidth: 220 }}
                        label={intl.formatMessage({ id: 'marketing.var.fallback' })} placeholder={intl.formatMessage({ id: 'marketing.var.fallbackPlaceholder' })}
                        value={m.fallback} onChange={e => this.setVarMapping(v, { fallback: e.target.value })} />
                    )}
                  </Box>
                </Box>
              );
            })}
          </>
        )}
        </Box>

        {/* Coluna direita: Template de Opt-in */}
        <Box sx={{ flex: '1 1 320px', minWidth: 280, maxWidth: 400 }}>
          {this.renderOptinBlock()}
        </Box>
      </Box>
    );
  }

  // Bloco "Template de Opt-in" (coluna direita do passo 3). Pré-seleciona o padrão do número;
  // o usuário pode trocar e o preview atualiza. Informa que o opt-in é enviado se o destinatário ainda não optou.
  renderOptinBlock() {
    const { intl } = this.props;
    const opt = this.state.optinTemplates.find(t => t.id === this.state.optinTemplateId);
    return (
      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', p: 2, backgroundColor: '#fafbff' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <HowToRegOutlinedIcon sx={{ fontSize: 18, color: '#277afe' }} />
          <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#333', flex: 1 }}>{intl.formatMessage({ id: 'marketing.optin.title' })}</Typography>
          <Tooltip title={intl.formatMessage({ id: 'marketing.optin.refresh' })}>
            <span>
              <IconButton size="small" onClick={() => this.loadOptinTemplates(this.state.senderId, true)} disabled={!this.state.senderId || this.state.loadingOptin}
                sx={{ color: '#8BC34A', '&:hover': { backgroundColor: '#f1f8e9' } }}>
                {this.state.loadingOptin ? <CircularProgress size={16} sx={{ color: '#8BC34A' }} /> : <RefreshIcon fontSize="small" />}
              </IconButton>
            </span>
          </Tooltip>
        </Box>
        <Typography sx={{ fontSize: 12, color: '#888', mb: 1.5 }}>{intl.formatMessage({ id: 'marketing.optin.subtitle' })}</Typography>

        {!this.state.senderId ? (
          <Alert severity="info">{intl.formatMessage({ id: 'marketing.optin.pickSenderFirst' })}</Alert>
        ) : this.state.optinTemplates.length === 0 && !this.state.loadingOptin ? (
          <Alert severity="warning">{intl.formatMessage({ id: 'marketing.optin.none' })}</Alert>
        ) : (
          <>
            {this.acField(intl.formatMessage({ id: 'marketing.optin.template' }),
              this.state.optinTemplates.map(t => ({ id: t.id, name: `${t.name}${t.system ? ` · ${intl.formatMessage({ id: 'marketing.optin.default' })}` : ''}` })),
              this.state.optinTemplateId,
              (id) => this.setState({ optinTemplateId: id }),
              { loading: this.state.loadingOptin })}

            {opt && (
              <Box sx={{ mt: 1.5, p: 1.5, backgroundColor: '#e9fde3', border: '1px solid #cfe8bf', borderRadius: '10px' }}>
                <Typography sx={{ fontSize: 11, color: '#5b9b1e', fontWeight: 600, mb: 0.5 }}>{intl.formatMessage({ id: 'marketing.optin.preview' })}</Typography>
                {opt.header && <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#0f172a', whiteSpace: 'pre-wrap', mb: 0.5 }}>{opt.header}</Typography>}
                <Typography sx={{ fontSize: 14, color: '#333', whiteSpace: 'pre-wrap' }}>{opt.body}</Typography>
                {opt.footer && <Typography sx={{ fontSize: 12, color: '#64748b', mt: 0.5, fontStyle: 'italic', whiteSpace: 'pre-wrap' }}>{opt.footer}</Typography>}
              </Box>
            )}

            <Alert severity="info" sx={{ mt: 1.5 }}>{intl.formatMessage({ id: 'marketing.optin.note' })}</Alert>
          </>
        )}
      </Box>
    );
  }

  renderStepReview() {
    const { intl } = this.props;
    const tpl = this.selectedTemplate();
    const optin = this.state.optinTemplates.find(t => t.id === this.state.optinTemplateId);
    return (
      <Box>
        <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', alignItems: 'flex-start' }}>
          {/* Esquerda: pré-visualização (exemplos lado a lado) */}
          <Box sx={{ flex: '1 1 560px', minWidth: 0 }}>
            <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 1 }}>{intl.formatMessage({ id: 'marketing.review.preview' })}</Typography>
            <Typography sx={{ fontSize: 12, color: '#888', mb: 1.5 }}>{intl.formatMessage({ id: 'marketing.review.previewNote' })}</Typography>
            {tpl && (
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-start' }}>
                {/* 1º exemplo: mensagem de opt-in (enviada antes, se o destinatário ainda não optou) */}
                {optin && (
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', flex: '1 1 240px', minWidth: 230 }}>
                    <Box sx={{ width: 28, height: 28, borderRadius: '50%', backgroundColor: '#e3edff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <HowToRegOutlinedIcon sx={{ fontSize: 16, color: '#277afe' }} />
                    </Box>
                    <Box sx={{ backgroundColor: '#eef4ff', border: '1px solid #d7e4ff', borderRadius: '10px', p: 1.2, flex: 1 }}>
                      <Typography sx={{ fontSize: 11, color: '#277afe', fontWeight: 700, mb: 0.3 }}>{intl.formatMessage({ id: 'marketing.review.optinExample' })}</Typography>
                      {optin.header && <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#0f172a', whiteSpace: 'pre-wrap', mb: 0.3 }}>{optin.header}</Typography>}
                      <Typography sx={{ fontSize: 13, color: '#222', whiteSpace: 'pre-wrap' }}>{optin.body}</Typography>
                      {optin.footer && <Typography sx={{ fontSize: 12, color: '#64748b', mt: 0.3, fontStyle: 'italic', whiteSpace: 'pre-wrap' }}>{optin.footer}</Typography>}
                    </Box>
                  </Box>
                )}
                {/* Demais: 2 exemplos da mensagem do template selecionado */}
                {SAMPLE_CONTACTS.slice(0, 2).map((c, i) => (
                  <Box key={i} sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', flex: '1 1 240px', minWidth: 230 }}>
                    <Box sx={{ width: 28, height: 28, borderRadius: '50%', backgroundColor: '#dcf8c6', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <WhatsAppIcon sx={{ fontSize: 16, color: '#25D366' }} />
                    </Box>
                    <Box sx={{ backgroundColor: '#dcf8c6', borderRadius: '10px', p: 1.2, flex: 1 }}>
                      <Typography sx={{ fontSize: 11, color: '#888', mb: 0.3 }}>{c.name || intl.formatMessage({ id: 'marketing.review.noName' })}{c.phone ? ` · ${c.phone}` : ''}</Typography>
                      <Typography sx={{ fontSize: 13, color: '#222' }}>{this.renderPreview(c)}</Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>

          {/* Direita: envio de teste. Título/nota com as MESMAS margens da esquerda, então
              o card de teste alinha no topo com os balões de exemplo. */}
          <Box sx={{ flex: '0 1 320px', minWidth: 280 }}>
            <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 1 }}>{intl.formatMessage({ id: 'marketing.review.test' })}</Typography>
            <Typography sx={{ fontSize: 12, color: '#888', mb: 1.5 }}>{intl.formatMessage({ id: 'marketing.review.testNote' })}</Typography>
            <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', p: 2, backgroundColor: '#fafbff' }}>
              <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'stretch', flexDirection: 'column' }}>
                <PhoneInput
                  country="br"
                  value={this.state.testPhone}
                  onChange={(value) => this.setState({ testPhone: value })}
                  countryCodeEditable
                  enableSearch
                  disableSearchIcon
                  inputStyle={{ height: 42, width: '100%', fontSize: 14, paddingLeft: 52 }}
                  buttonStyle={{ height: 42, borderTopLeftRadius: 4, borderBottomLeftRadius: 4 }}
                  dropdownStyle={{ width: 260 }}
                  specialLabel=""
                />
                <Button variant="outlined" startIcon={<WhatsAppIcon />} onClick={this.sendTest}
                  disabled={(this.state.testPhone || '').replace(/\D/g, '').length < 12}
                  sx={{ textTransform: 'none' }}>{intl.formatMessage({ id: 'marketing.review.sendTest' })}</Button>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Custo estimado — largura total (estica até o fim, responsivo) */}
        <Divider sx={{ my: 2 }} />
        {this.renderCostEstimate()}
      </Box>
    );
  }

  renderCostEstimate() {
    const { intl } = this.props;
    const c = this.costEstimate();
    const fmt = (v) => `US$ ${v.toFixed(4)}`;
    return (
      <Box sx={{ p: 1.5, borderRadius: '10px', border: '1px solid #ffe0b2', backgroundColor: '#fff8ef' }}>
        <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 1, color: '#b9770e' }}>{intl.formatMessage({ id: 'marketing.cost.title' })}</Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
          <Typography sx={{ fontSize: 13, color: '#555' }}>{intl.formatMessage({ id: 'marketing.cost.unit' })}: <b>{fmt(c.unit)}</b></Typography>
          <Typography sx={{ fontSize: 13, color: '#555' }}>{intl.formatMessage({ id: 'marketing.cost.recipients' })}: <b>{c.count.toLocaleString('pt-BR')}</b></Typography>
          <Box sx={{ flex: 1 }} />
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#b9770e' }}>{intl.formatMessage({ id: 'marketing.cost.total' })}: {fmt(c.total)}</Typography>
        </Box>
        <Typography sx={{ fontSize: 11, color: '#999', mt: 0.5 }}>{intl.formatMessage({ id: 'marketing.cost.note' })}</Typography>
      </Box>
    );
  }

  modeCard(mode, titleId, descId, icon) {
    const { intl } = this.props;
    const active = this.state.schedule.mode === mode;
    return (
      <Box onClick={() => this.patchSchedule({ mode })} sx={{
        flex: 1, minWidth: 150, cursor: 'pointer', p: 1.5, borderRadius: '10px',
        border: active ? '2px solid #8BC34A' : '1px solid #e0e0e0',
        backgroundColor: active ? '#f3fae9' : '#fff', transition: 'all .2s',
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {React.cloneElement(icon, { sx: { color: active ? '#5b9b1e' : '#9e9e9e', fontSize: 20 } })}
          <Typography sx={{ fontSize: 14, fontWeight: 700, color: active ? '#5b9b1e' : '#444' }}>{intl.formatMessage({ id: titleId })}</Typography>
        </Box>
        <Typography sx={{ fontSize: 12, color: '#888', mt: 0.5 }}>{intl.formatMessage({ id: descId })}</Typography>
      </Box>
    );
  }

  freqButton(freq, labelId) {
    const { intl } = this.props;
    const active = this.state.schedule.recurrence.freq === freq;
    return (
      <Button onClick={() => this.patchRecurrence({ freq })} variant={active ? 'contained' : 'outlined'} size="small"
        sx={{ textTransform: 'none', backgroundColor: active ? '#8BC34A' : 'transparent', color: active ? '#fff' : '#555', borderColor: '#cfcfcf', '&:hover': { backgroundColor: active ? '#7cb342' : 'rgba(0,0,0,0.03)' } }}>
        {intl.formatMessage({ id: labelId })}
      </Button>
    );
  }

  renderRecurrenceBuilder() {
    const { intl } = this.props;
    const r = this.state.schedule.recurrence;
    const timeField = (
      <TextField type="time" size="small" InputLabelProps={{ shrink: true }} sx={{ minWidth: 130 }}
        label={intl.formatMessage({ id: 'marketing.schedule.time' })} value={r.time} onChange={e => this.patchRecurrence({ time: e.target.value })} />
    );
    const intervalField = (label) => (
      <TextField type="number" size="small" InputLabelProps={{ shrink: true }} sx={{ width: 130 }} inputProps={{ min: 1 }}
        label={label} value={r.interval} onChange={e => this.patchRecurrence({ interval: Math.max(1, Number(e.target.value)) })} />
    );
    return (
      <Box sx={{ mt: 1.5, p: 2, border: '1px solid #e8e8e8', borderRadius: '10px', backgroundColor: '#fafafa' }}>
        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
          {this.freqButton('daily', 'marketing.schedule.freq.daily')}
          {this.freqButton('weekly', 'marketing.schedule.freq.weekly')}
          {this.freqButton('monthly', 'marketing.schedule.freq.monthly')}
        </Box>

        {r.freq === 'daily' && (
          <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center' }}>
            {intervalField(intl.formatMessage({ id: 'marketing.schedule.everyDays' }))}
            {timeField}
          </Box>
        )}

        {r.freq === 'weekly' && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center' }}>
              {intervalField(intl.formatMessage({ id: 'marketing.schedule.everyWeeks' }))}
              {timeField}
            </Box>
            <Box sx={{ display: 'flex', gap: 0.7 }}>
              {WEEKDAYS.map(d => {
                const on = r.weekdays.includes(d.id);
                return (
                  <Box key={d.id} onClick={() => this.toggleWeekday(d.id)} sx={{
                    width: 34, height: 34, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                    fontSize: 13, fontWeight: 700, transition: 'all .15s',
                    backgroundColor: on ? '#8BC34A' : '#fff', color: on ? '#fff' : '#888', border: on ? '1px solid #8BC34A' : '1px solid #ddd',
                  }}>{d.label}</Box>
                );
              })}
            </Box>
          </Box>
        )}

        {r.freq === 'monthly' && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <RadioGroup value={r.monthlyMode} onChange={e => this.patchRecurrence({ monthlyMode: e.target.value })}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                <FormControlLabel value="dayOfMonth" control={<Radio size="small" />} label={intl.formatMessage({ id: 'marketing.schedule.onDay' })} />
                <TextField type="number" size="small" InputLabelProps={{ shrink: true }} sx={{ width: 90 }} inputProps={{ min: 1, max: 31 }}
                  disabled={r.monthlyMode !== 'dayOfMonth'} value={r.dayOfMonth} onChange={e => this.patchRecurrence({ dayOfMonth: Math.min(31, Math.max(1, Number(e.target.value))) })} />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mt: 0.5 }}>
                <FormControlLabel value="nthWeekday" control={<Radio size="small" />} label={intl.formatMessage({ id: 'marketing.schedule.onThe' })} />
                <TextField select size="small" SelectProps={{ native: true }} sx={{ width: 130 }} disabled={r.monthlyMode !== 'nthWeekday'}
                  value={r.nth} onChange={e => this.patchRecurrence({ nth: Number(e.target.value) })}>
                  <option value={1}>{intl.formatMessage({ id: 'marketing.schedule.nth.1' })}</option>
                  <option value={2}>{intl.formatMessage({ id: 'marketing.schedule.nth.2' })}</option>
                  <option value={3}>{intl.formatMessage({ id: 'marketing.schedule.nth.3' })}</option>
                  <option value={4}>{intl.formatMessage({ id: 'marketing.schedule.nth.4' })}</option>
                  <option value={-1}>{intl.formatMessage({ id: 'marketing.schedule.nth.last' })}</option>
                </TextField>
                <TextField select size="small" SelectProps={{ native: true }} sx={{ width: 150 }} disabled={r.monthlyMode !== 'nthWeekday'}
                  value={r.nthWeekday} onChange={e => this.patchRecurrence({ nthWeekday: Number(e.target.value) })}>
                  {WEEKDAY_NAMES.map((n, i) => <option key={i} value={i}>{n}</option>)}
                </TextField>
              </Box>
            </RadioGroup>
            <Box>{timeField}</Box>
          </Box>
        )}

        {/* Condição de término (comum a todas as frequências): nunca | após N execuções | até a data */}
        <Divider sx={{ my: 1.5 }} />
        <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 0.5 }}>{intl.formatMessage({ id: 'marketing.schedule.ends' })}</Typography>
        <RadioGroup value={r.endMode || 'never'} onChange={e => this.patchRecurrence({ endMode: e.target.value })}>
          <FormControlLabel value="never" control={<Radio size="small" />} label={intl.formatMessage({ id: 'marketing.schedule.ends.never' })} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <FormControlLabel value="count" control={<Radio size="small" />} label={intl.formatMessage({ id: 'marketing.schedule.ends.afterN' })} />
            <TextField type="number" size="small" sx={{ width: 90 }} inputProps={{ min: 1 }} disabled={r.endMode !== 'count'}
              value={r.endCount} onChange={e => this.patchRecurrence({ endCount: Math.max(1, Number(e.target.value)) })} />
            <Typography sx={{ fontSize: 13, color: '#666' }}>{intl.formatMessage({ id: 'marketing.schedule.ends.executions' })}</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <FormControlLabel value="date" control={<Radio size="small" />} label={intl.formatMessage({ id: 'marketing.schedule.ends.onDate' })} />
            <TextField type="date" size="small" InputLabelProps={{ shrink: true }} sx={{ width: 180 }} disabled={r.endMode !== 'date'}
              value={r.endDate} onChange={e => this.patchRecurrence({ endDate: e.target.value })} />
          </Box>
        </RadioGroup>
      </Box>
    );
  }

  renderStepSchedule() {
    const { intl } = this.props;
    const s = this.state.schedule;
    return (
      <Box sx={{ maxWidth: 720 }}>
        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 1.5 }}>
          {this.modeCard('now', 'marketing.schedule.now', 'marketing.schedule.now.desc', <BoltIcon />)}
          {this.modeCard('once', 'marketing.schedule.once', 'marketing.schedule.once.desc', <EventOutlinedIcon />)}
          {this.modeCard('recurring', 'marketing.schedule.recurring', 'marketing.schedule.recurring.desc', <RepeatIcon />)}
        </Box>

        {s.mode === 'once' && (
          <TextField type="datetime-local" size="small" InputLabelProps={{ shrink: true }} sx={{ mt: 1, minWidth: 260 }}
            label={intl.formatMessage({ id: 'marketing.schedule.datetime' })} value={s.onceAt} onChange={e => this.patchSchedule({ onceAt: e.target.value })} />
        )}

        {s.mode === 'recurring' && this.renderRecurrenceBuilder()}

        {s.mode !== 'now' && (
          <Box sx={{ mt: 2, maxWidth: 300 }}>
            {this.acField(intl.formatMessage({ id: 'marketing.schedule.timezone' }), TIMEZONES, s.timezone, (id) => this.patchSchedule({ timezone: id }))}
          </Box>
        )}

        {/* Resumo legível do agendamento */}
        <Box sx={{ mt: 2, p: 1.2, px: 1.5, borderRadius: '8px', backgroundColor: '#eef7e3', border: '1px solid #cfe8bf', display: 'flex', alignItems: 'center', gap: 1 }}>
          <EventOutlinedIcon sx={{ fontSize: 18, color: '#5b9b1e' }} />
          <Typography sx={{ fontSize: 13, color: '#5b9b1e', fontWeight: 600 }}>{this.recurrenceSummary()}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Switches (bool on/off) */}
        <FormControlLabel sx={{ display: 'flex', m: 0, justifyContent: 'space-between' }} labelPlacement="start"
          control={<Switch checked={s.quietHours} onChange={() => this.patchSchedule({ quietHours: !s.quietHours })} sx={{ '& .Mui-checked': { color: '#8BC34A' }, '& .Mui-checked + .MuiSwitch-track': { backgroundColor: '#8BC34A !important' } }} />}
          label={<Typography sx={{ fontSize: 14 }}>{intl.formatMessage({ id: 'marketing.schedule.quiet' })}</Typography>} />
        <FormControlLabel sx={{ display: 'flex', m: 0, justifyContent: 'space-between', mt: 1 }} labelPlacement="start"
          control={<Switch checked={s.slice} onChange={() => this.patchSchedule({ slice: !s.slice })} sx={{ '& .Mui-checked': { color: '#8BC34A' }, '& .Mui-checked + .MuiSwitch-track': { backgroundColor: '#8BC34A !important' } }} />}
          label={<Typography sx={{ fontSize: 14 }}>{intl.formatMessage({ id: 'marketing.schedule.slice' })}</Typography>} />

        {s.slice && (
          <Box sx={{ display: 'flex', gap: 1.5, mt: 1, flexWrap: 'wrap', alignItems: 'center', pl: 1 }}>
            <TextField type="number" size="small" InputLabelProps={{ shrink: true }} sx={{ width: 160 }} inputProps={{ min: 1 }}
              label={intl.formatMessage({ id: 'marketing.schedule.sliceBatch' })} value={s.sliceBatch} onChange={e => this.patchSchedule({ sliceBatch: Math.max(1, Number(e.target.value)) })} />
            <TextField type="number" size="small" InputLabelProps={{ shrink: true }} sx={{ width: 160 }} inputProps={{ min: 1 }}
              label={intl.formatMessage({ id: 'marketing.schedule.sliceInterval' })} value={s.sliceInterval} onChange={e => this.patchSchedule({ sliceInterval: Math.max(1, Number(e.target.value)) })} />
            <Typography sx={{ fontSize: 12, color: '#888' }}>
              {intl.formatMessage({ id: 'marketing.schedule.sliceSummary' }, { batch: s.sliceBatch, interval: s.sliceInterval })}
            </Typography>
          </Box>
        )}

        <Alert severity="warning" icon={<WarningAmberIcon />} sx={{ mt: 2 }}>{intl.formatMessage({ id: 'marketing.schedule.costNote' })}</Alert>
      </Box>
    );
  }

  renderStepContent() {
    switch (this.state.activeStep) {
      case 0: return this.renderStepData();
      case 1: return this.renderStepRecipients();
      case 2: return this.renderStepTemplate();
      case 3: return this.renderStepReview();
      case 4: return this.renderStepSchedule();
      default: return null;
    }
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu, intl } = this.props;
    const { activeStep, saving, notification } = this.state;
    const isLast = activeStep === 4;

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open }, classes.actionsContent, { [classes.actionscontentShift]: actionsHeaderMenu.open })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <Button startIcon={<ArrowBackIcon />} onClick={this.cancel} sx={{ textTransform: 'none', color: '#666' }}>{intl.formatMessage({ id: 'marketing.back.list' })}</Button>
              <Typography sx={{ fontSize: 20, fontWeight: 700, color: '#333' }}>{intl.formatMessage({ id: this.isEdit ? 'marketing.edit.broadcast' : 'marketing.new.broadcast' })}</Typography>
            </Box>

            <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', backgroundColor: '#fff', p: 3 }}>
              <Stepper activeStep={activeStep} alternativeLabel sx={{
                mb: 4,
                // conector mais suave; preenche em verde até o step atual
                '& .MuiStepConnector-line': { borderColor: '#e6e6e6' },
                '& .MuiStep-root .Mui-active + .MuiStepConnector-root .MuiStepConnector-line': { borderColor: '#8BC34A' },
                '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line, & .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': { borderColor: '#8BC34A' },
                '& .MuiStepLabel-label': { color: '#9e9e9e', fontSize: 13, mt: 0.5 },
                '& .MuiStepLabel-label.Mui-active': { color: '#5b9b1e', fontWeight: 700 },
                '& .MuiStepLabel-label.Mui-completed': { color: '#5b9b1e', fontWeight: 600 },
              }}>
                {this.steps.map((s, i) => (
                  <Step key={s}>
                    <StepLabel StepIconComponent={StepCircle}
                      onClick={this.isEdit ? () => this.goToStep(i) : undefined}
                      sx={this.isEdit ? { cursor: 'pointer', '&, & *': { cursor: 'pointer !important' } } : undefined}>
                      {s}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>

              <Box sx={{ minHeight: 280 }}>{this.renderStepContent()}</Box>

              <Divider sx={{ my: 2 }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button onClick={activeStep === 0 ? this.cancel : this.back} sx={{ textTransform: 'none' }}>
                  {activeStep === 0 ? intl.formatMessage({ id: 'cancel' }) : intl.formatMessage({ id: 'marketing.back' })}
                </Button>
                {!isLast ? (
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    {/* No passo de revisão, Salvar rascunho fica à esquerda do Avançar (mesmo lugar do passo final) */}
                    {activeStep === 3 && (
                      <Button variant="outlined" onClick={this.saveDraftInline} disabled={saving}
                        sx={{ textTransform: 'none', borderColor: '#cfcfcf', color: '#444' }}>
                        {intl.formatMessage({ id: 'marketing.create.saveDraft' })}
                      </Button>
                    )}
                    <Button variant="contained" onClick={this.next} disabled={!this.canNext()}
                      sx={{ textTransform: 'none', backgroundColor: '#8BC34A', '&:hover': { backgroundColor: '#7cb342' } }}>
                      {intl.formatMessage({ id: 'marketing.next' })}
                    </Button>
                  </Box>
                ) : (
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                    {/* Editando uma programada já não é rascunho: oferece só "Salvar". Rascunho/criação mantêm o "Salvar rascunho". */}
                    {!(this.isEdit && this.state.loadedStatus === 'scheduled') && (
                      <Button variant="outlined" onClick={() => this.submit('draft')} disabled={saving}
                        sx={{ textTransform: 'none', borderColor: '#cfcfcf', color: '#444' }}>
                        {intl.formatMessage({ id: 'marketing.create.saveDraft' })}
                      </Button>
                    )}
                    {this.canPublish() && (
                      <Button variant="contained" onClick={() => this.submit(this.state.schedule.mode === 'now' ? 'active' : 'scheduled')} disabled={saving}
                        startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
                        sx={{ textTransform: 'none', backgroundColor: '#8BC34A', '&:hover': { backgroundColor: '#7cb342' } }}>
                        {this.isEdit
                          ? intl.formatMessage({ id: 'marketing.create.save' })
                          : (this.state.schedule.mode === 'now' ? intl.formatMessage({ id: 'marketing.create.send' }) : intl.formatMessage({ id: 'marketing.create.schedule' }))}
                      </Button>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          </Container>
          <Footer />
        </main>
        {saving && (
          <Overlay>
            <CircularProgress color="primary" />
          </Overlay>
        )}
        <CustomizedSnackbars variant={notification.variant} message={notification.message} isOpen={notification.open}
          toClose={() => this.setState({ notification: { ...notification, open: false } })} />
      </div>
    );
  }
}

const mapStateToProps = state => ({ headerMenu: state.headerMenu, actionsHeaderMenu: state.actionsHeaderMenu, userSession: state.userSession });
const mapDispatchToProps = dispatch => bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(MarketingBroadcastNew)));
